module.exports = __webpack_public_path__ + "static/media/alan.94f22eba.jpg";